import * as types from "./types";

export const mode = {
  namespaced: true,

  state: {
    mode: types.MODE_TOP,
    // トランジションさせる用
    modeTransition: types.MODE_TOP
  },
  getters: {
    // isAreaMode() {
    //   console.log("this", this);
    //   return this.mode === types.MODE_AREA;
    // }
  },
  mutations: {
    setMode(state, mode) {
      state.mode = mode;
      state.modeTransition = mode;
    },
    setModeTransition(state, mode) {
      state.modeTransition = mode;
    }
  },
  actions: {
    [types.SET_MODE]({ commit }, mode) {
      commit("setMode", mode);
    },
    [types.SET_MODE_TRANSITION]({ commit }, mode) {
      commit("setModeTransition", mode);
    }
  }
};
